import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "@/lib/api";

const BANNER = "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800";

export default function Gallery() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/gallery").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="gallery-page">
      <section className="relative h-[34vh] min-h-[240px] flex items-center justify-center overflow-hidden">
        <img src={BANNER} alt="Travel gallery" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-brand-navy/65" />
        <div className="relative z-10 text-center px-5">
          <h1 className="text-4xl sm:text-6xl font-heading font-semibold text-white">Travel Gallery</h1>
          <p className="mt-3 text-white/80 font-body">Real moments from our travellers' journeys</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 md:px-10 py-14 min-h-[40vh]">
        {loading ? (
          <p className="text-center text-[#8B89A4] py-20">Loading memories...</p>
        ) : items.length === 0 ? (
          <p className="text-center text-[#8B89A4] py-20" data-testid="gallery-empty">Gallery coming soon — beautiful trip photos on the way!</p>
        ) : (
          <div className="columns-2 md:columns-3 lg:columns-4 gap-4 [column-fill:_balance]" data-testid="gallery-grid">
            {items.map((it, i) => (
              <motion.div
                key={it.id}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.5, delay: (i % 4) * 0.05 }}
                className="group relative mb-4 break-inside-avoid overflow-hidden rounded-2xl shadow-[0_8px_30px_rgba(46,42,128,0.10)]"
                data-testid={`gallery-item-${it.id}`}
              >
                <img src={it.image} alt={it.caption || "Trip photo"} loading="lazy" className="w-full transition-transform duration-700 group-hover:scale-105" />
                {it.caption && (
                  <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-brand-navy/90 to-transparent p-4 pt-10 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <p className="text-white text-sm font-heading">{it.caption}</p>
                  </div>
                )}
              </motion.div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
